import { gql } from '@apollo/client';
import { SKU_FIELDS } from './queries';

export const INSERT_ITEM_SKU = gql`
    ${SKU_FIELDS}

    mutation InsertItemSku($object: item_dimensions_insert_input!) {
        insert_item_dimensions_one(object: $object) {
            ...SkuFields
        }
    }
`;

export const UPDATE_ITEM_SKU = gql`
    ${SKU_FIELDS}

    mutation UpdateItemSku($item_dimension_id: uuid!, $set: item_dimensions_set_input!) {
        update_item_dimensions_by_pk(pk_columns: { item_dimension_id: $item_dimension_id }, _set: $set) {
            ...SkuFields
        }
    }
`;

export const DELETE_ITEM_SKU = gql`
    mutation DeleteItemSku($item_dimension_id: uuid!) {
        delete_item_dimensions_by_pk(item_dimension_id: $item_dimension_id) {
            item_dimension_id
        }
    }
`;

// Bulk upsert for CSV import. Upserts on the (client_id, sku) unique constraint.
// update_columns is limited to the columns present in the uploaded CSV so a
// partial re-import can't null out stored values (empty = insert-new-only).
export const BULK_UPSERT_ITEM_SKUS = gql`
    mutation BulkUpsertItemSkus($objects: [item_dimensions_insert_input!]!, $update_columns: [item_dimensions_update_column!]!) {
        insert_item_dimensions(
            objects: $objects
            on_conflict: { constraint: item_dim_uniq_idx, update_columns: $update_columns }
        ) {
            affected_rows
        }
    }
`;

export const INSERT_SKU_DOCUMENTS = gql`
    mutation InsertSkuDocuments($objects: [item_dimension_documents_insert_input!]!) {
        insert_item_dimension_documents(objects: $objects) {
            returning {
                item_dimension_document_id
                item_dimension_id
                name
                link
                file_type
            }
        }
    }
`;

export const DELETE_SKU_DOCUMENT = gql`
    mutation DeleteSkuDocument($item_dimension_document_id: uuid!) {
        delete_item_dimension_documents_by_pk(item_dimension_document_id: $item_dimension_document_id) {
            item_dimension_document_id
        }
    }
`;
